// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var distributionRouter = {
  path: '/distribution',
  component: Layout,
  redirect: '/distribution/index',
  name: 'Distribution',
  meta: {
    title: '分销',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/distribution/index');
    },
    name: 'distributionIndex',
    meta: {
      title: '分销员管理',
      icon: ''
    }
  }, {
    path: 'distributionconfig',
    component: function component() {
      return import('@/views/distribution/config/index');
    },
    name: 'distributionConfig',
    meta: {
      title: '分销配置',
      icon: ''
    }
  }, {
    path: 'distributionpower',
    component: function component() {
      return import('@/views/distribution/power/index');
    },
    name: 'distributionPower',
    meta: {
      title: '权益模板',
      icon: ''
    }
  }, {
    path: 'distributionscore',
    component: function component() {
      return import('@/views/distribution/score/index');
    },
    name: 'distributionScore',
    meta: {
      title: '业绩管理',
      icon: ''
    },
    children: [{
      path: 'self',
      name: 'Self',
      meta: {
        title: '个人业绩'
      },
      component: function component() {
        return import('@/views/distribution/score/self');
      },
      children: [{
        path: 'selfscore',
        name: 'selfScore',
        meta: {
          title: '个人业绩汇总',
          noCache: true
        },
        component: function component() {
          return import('@/views/distribution/score/self/selfscore');
        }
      }, {
        path: 'selfscoreflow',
        name: 'selfscoreFlow',
        meta: {
          title: '个人业绩明细',
          noCache: true
        },
        component: function component() {
          return import('@/views/distribution/score/self/selfscoreflow');
        }
      }, {
        path: 'selfscoregroup',
        name: 'selfscoreGroup',
        meta: {
          title: '个人业绩分组',
          noCache: true
        },
        component: function component() {
          return import('@/views/distribution/score/self/selfscoregroup');
        }
      }, {
        path: 'selfsteam',
        name: 'selfsTeam',
        meta: {
          title: '团队业绩',
          noCache: true
        },
        component: function component() {
          return import('@/views/distribution/score/self/selfsteam');
        }
      }]
    }, {
      path: 'invitation',
      name: 'Invitation',
      meta: {
        title: '销售业绩'
      },
      component: function component() {
        return import('@/views/distribution/score/invitation');
      },
      children: [{
        path: 'invitationscore',
        name: 'invitationScore',
        meta: {
          title: '销售业绩汇总',
          noCache: true
        },
        component: function component() {
          return import('@/views/distribution/score/invitation/invitationscore');
        }
      }, {
        path: 'invitationscoreflow',
        name: 'invitationscoreFlow',
        meta: {
          title: '销售业绩明细',
          noCache: true
        },
        component: function component() {
          return import('@/views/distribution/score/invitation/invitationscoreflow');
        }
      }, {
        path: 'invitationscoregroup',
        name: 'invitationscoreGroup',
        meta: {
          title: '销售业绩分组',
          noCache: true
        },
        component: function component() {
          return import('@/views/distribution/score/invitation/invitationscoregroup');
        }
      }]
    }, {
      path: 'relation',
      name: 'Relation',
      meta: {
        title: '服务业绩'
      },
      component: function component() {
        return import('@/views/distribution/score/relation');
      },
      children: [{
        path: 'relationscore',
        name: 'relationScore',
        meta: {
          title: '服务业绩汇总',
          noCache: true
        },
        component: function component() {
          return import('@/views/distribution/score/relation/relationscore');
        }
      }, {
        path: 'relationscoreflow',
        name: 'relationscoreFlow',
        meta: {
          title: '服务业绩明细',
          noCache: true
        },
        component: function component() {
          return import('@/views/distribution/score/relation/relationscoreflow');
        }
      }, {
        path: 'relationscoresmall',
        name: 'relationscoreSmall',
        meta: {
          title: '小区位置记录',
          noCache: true
        },
        component: function component() {
          return import('@/views/distribution/score/relation/relationscoresmall');
        }
      }, {
        path: 'relationscoregroup',
        name: 'relationscoreGroup',
        meta: {
          title: '服务业绩分组',
          noCache: true
        },
        component: function component() {
          return import('@/views/distribution/score/relation/relationscoregroup');
        }
      }]
    }, {
      path: 'everyday',
      name: 'everyday',
      meta: {
        title: '每日业绩'
      },
      component: function component() {
        return import('@/views/distribution/everyday/index');
      }
    }, {
      path: 'statement',
      name: 'statement',
      meta: {
        title: '商品报表'
      },
      component: function component() {
        return import('@/views/distribution/statement/index');
      }
    }]
  }, {
    path: 'clearing',
    component: function component() {
      return import('@/views/distribution/clearing');
    },
    name: 'clearing',
    meta: {
      title: '模式管理',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'clearingtask',
      component: function component() {
        return import('@/views/distribution/clearing/clearingtask/index');
      },
      name: 'clearingtask',
      meta: {
        title: '结算任务',
        icon: ''
      }
    }, {
      path: 'clearingroll',
      component: function component() {
        return import('@/views/distribution/clearing/clearingroll');
      },
      name: 'clearingroll',
      meta: {
        title: '结算名单',
        icon: ''
      }
    }, {
      path: 'clearingbonus',
      component: function component() {
        return import('@/views/distribution/clearing/clearingbonus');
      },
      name: 'clearingbonus',
      meta: {
        title: '结算奖金',
        icon: ''
      }
    }, {
      path: 'clearingdetail',
      component: function component() {
        return import('@/views/distribution/clearing/clearingdetail');
      },
      name: 'clearingdetail',
      meta: {
        title: '奖金明细',
        icon: ''
      }
    }, {
      path: 'clearingmarket',
      component: function component() {
        return import('@/views/distribution/clearing/clearingmarket');
      },
      name: 'clearingmarket',
      meta: {
        title: '结算销售关系',
        icon: ''
      }
    }, {
      path: 'clearingserve',
      component: function component() {
        return import('@/views/distribution/clearing/clearingserve');
      },
      name: 'clearingserve',
      meta: {
        title: '结算服务关系',
        icon: ''
      }
    }, {
      path: 'clearingrollextra',
      component: function component() {
        return import('@/views/distribution/clearing/clearingrollextra');
      },
      name: 'clearingrollextra',
      meta: {
        title: '额外名单',
        icon: ''
      }
    }, {
      path: 'operatingcenter',
      component: function component() {
        return import('@/views/distribution/clearing/operatingcenter');
      },
      name: 'operatingcenter',
      meta: {
        title: '运营中心明细',
        icon: ''
      }
    }, {
      path: 'operatingcentercollect',
      component: function component() {
        return import('@/views/distribution/clearing/operatingcentercollect');
      },
      name: 'operatingcenter',
      meta: {
        title: '运营中心汇总',
        icon: ''
      }
    }, {
      path: 'clearingperf',
      component: function component() {
        return import('@/views/distribution/clearing/clearingperf');
      },
      name: 'clearingperf',
      meta: {
        title: '月度业绩',
        icon: ''
      }
    }, {
      path: 'clearingsett',
      component: function component() {
        return import('@/views/distribution/clearing/clearingsett');
      },
      name: 'clearingsett',
      meta: {
        title: '月度分红结算',
        icon: ''
      }
    }, {
      path: 'clearingrest',
      component: function component() {
        return import('@/views/distribution/clearing/clearingrest');
      },
      name: 'clearingrest',
      meta: {
        title: '月度奖金返还',
        icon: ''
      }
    }, {
      path: 'clearingextend',
      component: function component() {
        return import('@/views/distribution/clearing/extend/index');
      },
      name: 'clearingextend',
      meta: {
        title: '推广任务',
        icon: ''
      }
    }, {
      path: 'clearingextendinfo',
      component: function component() {
        return import('@/views/distribution/clearing/extend/extendinfo');
      },
      name: 'clearingextendinfo',
      meta: {
        title: '推广服务明细',
        icon: ''
      }
    }]
  }]
};
export default distributionRouter;